const APP_VERSION = import.meta.env.PACKAGE_VERSION;

export function PlatformFooter() {
  return (
    <footer className="flex h-10 shrink-0 items-center justify-between border-t border-border bg-background px-6 text-xs text-muted-foreground">
      <span>Service Portal · Platform Console</span>
      <span>v{APP_VERSION}</span>
    </footer>
  );
}
